import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './noticeDetail.css';
import API_BASE_URL from '../../config/api';

const NoticeDetail = () => {
    const { id } = useParams();

    const [notice, setNotice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const getToday = () => {
            const now = new Date();

            const year = now.getFullYear();

            const month = String(
                now.getMonth() + 1
            ).padStart(2, '0');

            const day = String(
                now.getDate()
            ).padStart(2, '0');

            return `${year}-${month}-${day}`;
        };

        const fetchNotice = async () => {
            try {
                setLoading(true);
                setError('');

                /*
                 * 공지사항 상세 조회
                 */
                const response = await fetch(
                    `${API_BASE_URL}/api/notices/${id}`
                );

                if (response.status === 404) {
                    throw new Error(
                        '존재하지 않는 공지사항입니다.'
                    );
                }

                if (!response.ok) {
                    throw new Error(
                        '공지사항 조회에 실패했습니다.'
                    );
                }

                const data = await response.json();

                let currentNotice = data;

                /*
                 * 오늘 해당 공지사항을 조회했는지 확인
                 */
                const storageKey =
                    `mtmedia_notice_${id}_viewed_date`;

                const today = getToday();

                const viewedDate =
                    localStorage.getItem(storageKey);

                /*
                 * 오늘 처음 조회한 경우에만 조회수 증가
                 */
                if (viewedDate !== today) {
                    /*
                     * StrictMode에서도 중복 요청이 발생하지 않도록
                     * API 요청 전에 먼저 localStorage에 저장
                     */
                    localStorage.setItem(
                        storageKey,
                        today
                    );

                    try {
                        const viewResponse = await fetch(
                            `${API_BASE_URL}/api/notices/${id}/view`,
                            {
                                method: 'POST'
                            }
                        );

                        if (viewResponse.ok) {
                            const viewData =
                                await viewResponse.json();

                            currentNotice = {
                                ...currentNotice,
                                view_count:
                                    viewData.view_count
                            };
                        } else {
                            /*
                             * 조회수 증가 실패 시
                             * 다시 시도할 수 있도록 기록 제거
                             */
                            localStorage.removeItem(
                                storageKey
                            );
                        }
                    } catch (viewError) {
                        localStorage.removeItem(
                            storageKey
                        );

                        console.error(
                            '조회수 증가 오류:',
                            viewError
                        );
                    }
                }

                setNotice(currentNotice);
            } catch (error) {
                console.error(
                    '공지사항 상세 조회 오류:',
                    error
                );

                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchNotice();
    }, [id]);

    const formatDate = (date) => {
        if (!date) {
            return '';
        }

        return new Date(date)
            .toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            })
            .replace(/\. /g, '.')
            .replace(/\.$/, '');
    };

    if (loading) {
        return (
            <div className="notice-detail-state">
                공지사항을 불러오는 중입니다.
            </div>
        );
    }

    if (error || !notice) {
        return (
            <div className="notice-detail-state">
                <p>
                    {error ||
                        '공지사항을 찾을 수 없습니다.'}
                </p>

                <Link to="/support">
                    공지사항 목록으로
                </Link>
            </div>
        );
    }

    return (
        <div className="notice-detail-page">
            <section className="notice-detail-sub-visual">
                <div className="notice-detail-sub-overlay"></div>

                <div className="notice-detail-sub-inner">
                    <p>
                        CUSTOMER SUPPORT
                    </p>

                    <h1>
                        공지사항
                    </h1>

                    <div className="notice-detail-breadcrumb">
                        <Link to="/">
                            HOME
                        </Link>

                        <span>
                            ›
                        </span>

                        <strong>
                            공지사항
                        </strong>
                    </div>
                </div>
            </section>

            <section className="notice-detail-section">
                <div className="notice-detail-container">
                    <div className="notice-detail-heading">
                        <p>
                            NOTICE
                        </p>

                        <h2>
                            공지사항
                        </h2>
                    </div>

                    <article className="notice-detail">
                        <div className="notice-detail-header">
                            <span className="notice-detail-type">
                                {notice.notice_type}
                            </span>

                            <h3>
                                {notice.title}
                            </h3>

                            <div className="notice-detail-info">
                                <span>
                                    작성자 {notice.writer}
                                </span>

                                <span className="notice-detail-divider"></span>

                                <span>
                                    {formatDate(
                                        notice.created_at
                                    )}
                                </span>

                                <span className="notice-detail-divider"></span>

                                <span>
                                    조회 {notice.view_count}
                                </span>
                            </div>
                        </div>

                        <div className="notice-detail-content">
                            {notice.content}
                        </div>
                    </article>

                    <div className="notice-detail-bottom">
                        <Link
                            to="/support"
                            className="notice-detail-list-button"
                        >
                            <i className="mdi mdi-format-list-bulleted"></i>

                            목록으로
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NoticeDetail;